export const askAiExcludedPages = [
  "account/setup",
  "not-found",
  "access-denied",
];
